import { ReactElement, useState } from "react"

import { AppShell, Box, Button, Group, Stack, Text } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { Icon2fa, IconBellRinging, IconDatabaseImport, IconFingerprint, IconKey, IconReceipt2, IconSettings } from "@tabler/icons-react"

const routes = [
    { Icon: IconBellRinging, label: "Notifications", link: "" },
    { Icon: IconReceipt2, label: "Billing", link: "" },
    { Icon: IconFingerprint, label: "Security", link: "" },
    { Icon: IconKey, label: "SSH Keys", link: "" },
    { Icon: IconDatabaseImport, label: "Databases", link: "" },
    { Icon: Icon2fa, label: "Authentication", link: "" },
    { Icon: IconSettings, label: "Other Settings", link: "" },
]

export function App(): ReactElement {
    const [opened, { toggle }] = useDisclosure()

    const [active, setActive] = useState(routes[0].label)

    const items = routes.map(({ Icon, label }, index) => (
        <Button
            fullWidth
            justify="flex-start"
            key={`${index}${label}`}
            leftSection={<Icon size={14} />}
            onClick={() => setActive(label)}
            variant={active === label ? "light" : "subtle"}
        >
            {label}
        </Button>
    ))

    return (
        <AppShell header={{ collapsed: true, height: 60 }} navbar={{ breakpoint: "sm", collapsed: { mobile: !opened }, width: { lg: 300, sm: 200 } }} withBorder={false}>
            <AppShell.Header />
            <AppShell.Navbar pt="lg" px="xl">
                <Text fw={900} mb="xl" ml="md" size="xl">
                    WireIndex
                </Text>

                <nav>
                    <Stack align="flex-start" gap="xs" justify="flex-start">
                        {items}
                    </Stack>
                </nav>
            </AppShell.Navbar>
            <AppShell.Main>
                <Box bg="off.0" ml={{ sm: "xl" }} p="xl">
                    <Group justify="space-between">
                        <Text>Main</Text>
                        <Button variant="filled">Click</Button>
                    </Group>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </Box>
            </AppShell.Main>
        </AppShell>
    )
}
